<template>
  <main class="content">
    <!-- content -->
    <div class="audience-bg"></div>
    <section class="article-page" v-if="news.id">
      <div class="container">
        <div class="article-page__wrapper">
          <h3 class="article-page-title">{{news.name}}</h3>
          <div class="article-page__item">
            <picture>
              <img :src="news.cf[299]">
            </picture>
            <p v-html="news.html"></p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'news',
  data () {
    return {
      news: {}
    }
  },
  methods: {
    initPage () {
      axios.get('https://urist2.v-avtoservice.com/list/get-listc?id=' + this.$route.params.id).then(response => {
        this.news = response.data
      })
    },
    showModal (id, text) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
    }
  },
  mounted () {
    this.initPage()
  },
  watch: {
    $route (to, from) {
      this.initPage()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/news.vue